/**
 * Created by adas27 on 03/08/2017.
 */

(function (Rayban, tealium_data2track, $) {

  var analytics = (function () {
    return {
      productsInMiniCart: function(){
        tealium_data2track.push({
          'id': 'WCS-X-MiniCart--Open',
          'Products': $('#products_added_data').data() ? $('#products_added_data').data().productsData : {}
        });
      },
      needHelpSuccess: function(){
        tealium_data2track.push({
          'id': 'Help-Proceed'
        });
      },
      needHelpError: function(errorDesc){
        tealium_data2track.push({
          'id': 'Error',
          'Error_Source': 'Server',
          'Error_Code': 'Help - ' + errorDesc
        });
      },
      giftCardApplySuccess: function(giftCardNumber){
        tealium_data2track.push({
          'id': 'OrderGiftCard-Applied',
          'Order_GiftCardCode': giftCardNumber
        });
      },
      giftCardApplyError: function(errorDesc, giftCardNumber){
        tealium_data2track.push({
          'id': 'OrderGiftCard-Tentative',
          'Error_Source': 'User',
          'Error_Code': 'GiftCard - ' + errorDesc,
          'Order_GiftCardCode': giftCardNumber
        });
      },
      promoCodeApplySuccess: function(promoCode){
        tealium_data2track.push({
          'id': 'OrderDiscountCode-Applied',
          'Order_DiscountCode': promoCode
        });
      },
      promoCodeApplyError: function(errorDesc, promoCode, errorOrigin){
        tealium_data2track.push({
          'id': 'OrderDiscountCode-Tentative',
          'Error_Source': 'User',
          'Error_Code': 'PromoCode - Wrong Code',
          'Error_Message': errorDesc,
          'Order_DiscountCode' : promoCode
        });
      },
      deliveryLoginSuccess: function(device, emailId){
    	utagupdatefromcookie();
      },
      facebookLoginSuccess: function(fbFlag) {
        utagupdatefromcookie(fbFlag);
      },
      facebookLoginError: function() {
        tealium_data2track.push({
          'id': 'Error',
          'Error_Source': 'User',
          'Error_Code': 'Login - Facebook',
          'Error_Message': 'younger than 16 years old'
        });
      },
      facebookDeliveryLoginSuccess: function(fbFlag) {
        utagupdatefromcookie(fbFlag);
      },
      deliveryLoginError: function(errorDesc){
        tealium_data2track.push({
          'id': 'Error',
          'Error_Source': 'User',
          'Error_Code': 'Login',
          'Error_Details': errorDesc
        });
      },
      accountCreateSuccess: function(emailId){
        tealium_data2track.push({
          'id': 'WCS-M-CheckoutThankYou-Account-Create'
        });
      },
      accountCreateError: function(errorDesc){
        tealium_data2track.push({
          'id': 'Error',
          'Error_Source': 'Server',
          'Error_Code': 'Account Creation - ' + errorDesc
        });
      },
      proceedToPaymentError: function(errorDesc){
        tealium_data2track.push({
          'id': 'Error',
          'Error_Source': 'User',
          'Error_Code': 'Payment',
          'Error_Details': errorDesc
        });
      },
      contactUsSuccess: function(){
        tealium_data2track.push({
          'id':'ContactUs'
        });
      },
      contactUsError: function(info, errorDesc){
        tealium_data2track.push({
          'id': 'Error',
          'Error_Source': 'Server',
          'Error_Message': errorDesc,
          'Error_Code': info + errorDesc
        });
      },
      applePayAjaxError: function(errorMsg){
        tealium_data2track.push({
          'id':'Error',
          'Error_Source': 'Server',
          'Error_Message': errorMsg,
          'Error_Code': 'Payment - Encounted a error from ApplePay'
        });
      },
      shopbagShippingMethodFetchError: function(zipcode, partnumber){
        tealium_data2track.push({
          'id' : 'Error',
          'Error_Source' : 'User',
          'Error_Message' : 'Invalid zip code ' + zipcode + ' with UPCs: ' + partnumber,
          'Error_Code' : 'Checkout',
          'Error_Details' : 'Invalid zip code'
        });
      },
      checkValidZipError: function(){
        tealium_data2track.push({
          'id' : 'Error',
          'Error_Source' : 'User',
          'Error_Message' : '',
          'Error_Code' : 'Checkout',
          'Error_Details' : 'missing zip code'
        });
      },
      forterPaymentFailed: function(errorMsg){
	    tealium_data2track.push({
		    'id' : 'Error',
		    'Error_Source' : 'Anomaly',
		    'Error_Message' : errorMsg,
		    'Error_Code' : 'Payment',
		    'Error_Details' : 'Forter payment refused - '+errorMsg
		});
      }
    };
  })();

  $.extend(Rayban.analytics = Rayban.analytics || {}, analytics);
})(
  window.Rayban = window.Rayban || {},
  window.tealium_data2track = window.tealium_data2track || [],
  window.jQuery
);
